import { render, staticRenderFns } from "./ChatsSlider.vue?vue&type=template&id=360191f2&"
import script from "./ChatsSlider.vue?vue&type=script&lang=js&"
export * from "./ChatsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports